<template>
  <div class="admin">
    <v-navigation-drawer v-model="drawer" app>
      <v-list>
        <v-list-item link @click="$store.commit('setActiveTab', 'booking')">
          <v-list-item-icon>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Онлайн записи</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          @click="$store.commit('setActiveTab', 'certificates')"
        >
          <v-list-item-icon>
            <v-icon>mdi-certificate</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Сертификаты</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="primary" @click="logout"> Выйти </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>{{ $store.state.active_tab_text }}</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <Bookings v-if="$store.state.active_tab == 'booking'" />
      <Certificates v-if="$store.state.active_tab == 'certificates'" />
      <BookingMore />
      <CertificateMore />
    </v-main>
  </div>
</template>

<script>
import Bookings from "../components/Bookings.vue";
import Certificates from "../components/Certificates.vue";
import BookingMore from "../components/BookingMore.vue";
import CertificateMore from "../components/CertificateMore.vue";

export default {
  name: "Admin",
  components: {
    Bookings,
    Certificates,
    BookingMore,
    CertificateMore,
  },
  data: () => ({
    items: [
      { title: "Dashboard", icon: "mdi-view-dashboard" },
      { title: "Account", icon: "mdi-account-box" },
      { title: "Admin", icon: "mdi-gavel" },
    ],
    drawer: null,
  }),
  methods: {
    logout() {
      localStorage.clear();
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>